import { FCX } from "@datassential/platform-ui-lib";
import Loader from "@components/Loader";
import cn from "classnames";
import './ContentWidget.scss';

type Modifiers = 'pad-s' | 'pad-none';

const ContentWidget: FCX<{
    modifiers?: Modifiers[];
    isLoading?: boolean;
}> = ({
    modifiers = [],
    children,
    className,
    style,
    testId,
    isLoading = false,
    ...rest
}) => {
    return (
        <div
            className={
                cn(
                    "ContentWidget",
                    className,
                    ...modifiers.map(modifier => `is-${modifier}`),
                )}
            data-testid={testId}
            style={style}
            {...rest}
        >
            {isLoading && <Loader />}
            {children}
        </div>
    );
};

export default ContentWidget;